<template>
    <div class="block-search">
        <search-input v-model="inputValue" clear type="block" :gray="gray" :class="[{'no-button': noButton == ''}]" :placeholder="placeholder" :page-type="pageType"></search-input>
        <div v-if="collection || collection == ''" class="collection"><img @click="toPage('/favorites', {index: collection})" src="@/assets/img/collection.png" /></div>
        <slot></slot>
    </div>
</template>

<script>
import searchInput from "../searchInput.vue";

export default {
    name: "block-search",
    components: { searchInput },
    model: {
        prop: 'modelValue', // 默认是value
        event: 'modelInput', // 默认是input
    },
    props: {
        collection: String,
        gray: String,
        noButton: String,
        modelValue: String || Number,
        placeholder: String,
        pageType: String
    },
    data() {
        return {
            inputValue: this.modelValue,
        }
    },
    watch: {
        inputValue(val) {
            this.$emit("modelInput", val)
        },
        modelValue(val) {
            this.inputValue = val;
        }
    },
    methods: {
        toPage(path, query) {
            this.$router.push({
                path, query
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.block-search {
    display: flex;
    align-items: center;

    .search-input {
        flex: 1;
    }

    /deep/ .no-button {
        .button {
            display: none;
        }
    }

    .collection {
        width: 20px;
        height: 20px;
        margin-left: 24px;
        margin-right: 6px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/search.vue